import React, { useEffect, useState, useRef } from 'react';
import BOM from "@system/config/bom";
import PriceTable from 'src/component/custom/PriceTable';
import DisplayQtyMinQtyMult from 'src/component/custom/DisplayQtyMinQtyMult';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import FactoryLeadTimeDisplay from 'src/component/custom/FactoryLeadTimeDisplay';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import { useCartStore } from 'src/hooks/cart';
import System from 'src/helper/system';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';
import { useProductStore } from 'src/hooks/product';
import Constants from 'src/helper/Constants';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import remove from "src/assets/images/remove-search-match.svg";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";

const BomSearchMatchPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { data, SetStatus } = props
    const [multipleSearchData, setMultipleSearchData] = useState([]);
    const modalRef = useRef(null);
    const [{ bom_detail_by_bom_id,bom_detail_by_bom_id_type,bom_project_list}, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui, get_MultipleMatch_Product_Search }, { swap_part_number, set_bom_multi_match_trigger, update_customer_part_number_by_bom_detail_by_id, create_part_list }] = useBOMStore();
    const currentBom = data && data.single_bom
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [{ }, { get_product_assets }, { }] = useProductStore();
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [selectedValue, setSelectedValue] = useState([]);
    const [loader, setLoader] = useState(false);
    const bom_id = System.getParams().bomId;

    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onHide();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalRef]);

    useEffect(() => {
        getProductData()
    }, [data]);

    const onHide = () => {
        SetStatus(false)
        setSelectedValue([])
    };

    const getProductData = async () => {
        let res = await get_MultipleMatch_Product_Search(currentBom.bomDetailId);
        await get_product_assets(res.Products)
        setMultipleSearchData(res)
    }
    const onSwapHandler = async (partData) => {

        const params = {
            partNumber: partData.ERPMFRPartNumber || '',
            itemNumber: partData.ItemNumber || false,
            erpPartNumber: partData.ERPPartNumber,
            manufacturerPartNumber: partData.ERPMFRPartNumber || '',
            quantity: partData.QtyMin,
            lifeCycleRisk: partData.LifeCycleRisk || '-',
            bomDetailId: currentBom.bomDetailId,
            bomId: currentBom.bomId,
            customerPartNumber: CART_BEFORE_TO_SEND_SERVER[partData.ItemNumber]?.CPN || "",
            designWinFlag: currentBom?.designWinFlag,
            manufacturerName: partData.ManufacturerName
        };

        setSelectedValue([...selectedValue, params]);

    };
    const removeSelectedValue = async (partData) => {
        const updatedValue = selectedValue.filter(item => item.erpPartNumber !== partData);
        setSelectedValue(updatedValue);
    }

    const onApplySelected = async () => {

        if (selectedValue.length === 0) return; // return if no values are selected
        setLoader(true)
        const swapPartRes = await swap_part_number(selectedValue[0]);
        if (swapPartRes?.data) {
            if (selectedValue.length > 1) {
                const valuesToSwap = selectedValue.slice(1);
                const paramCheck = {
                    bomIds: bom_id || '',
                    partList: valuesToSwap
                };
                await create_part_list(paramCheck);
            }
            await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(currentBom.bomId);
            onHide();
            setLoader(false)
            multipleMatchesEvent(selectedValue); 
            set_bom_multi_match_trigger({
                BOMTriggerVal: 'BOM_EXACT_TRIGGER'
            });
        }
    };
    
    //By Ramya Kannan [BOM MUltiple matches - Adobe script ]
  function multipleMatchesEvent(selectedProdData) {
    let bomDetails = {
      bomId: bom_detail_by_bom_id.bomId,
      bomName: bom_detail_by_bom_id.bomName,
      exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
      nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
      multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
      newBOM : bom_detail_by_bom_id?.newBOM,
      source: bom_detail_by_bom_id?.source
    };
    if(bom_project_list){
      bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
    }

    let prodDetails = [];
    selectedProdData.map((data,ind)=> {
        let copyObj = {...data}
        copyObj.qas = get_inventory_by_id(copyObj.ItemNumber)?.inventoryQty || 0;
        let priceVal = getPricing(copyObj);
        copyObj.priceSource = priceVal?.priceSource;
        copyObj.unitPrice = copyObj.unitPrice || priceVal?.marketPrice;
        copyObj.subtotal = copyObj.subtotal || ((priceVal?.marketPrice)? (priceVal?.marketPrice) * priceVal?.quantity : 0);
        prodDetails[ind]= copyObj;
    })
   
    localStorage.setItem("adobeEventType", "bomProdSelectionMultipleResolved");

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({
        prodDetails,
        bomDetails,
      });
    }
  }

  
const getPricing = (ele) => {
    let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
    return priceValues && priceValues[0];
}


    return (
        <>
            <div ref={modalRef} className="avnet-modal avnet-modal-right modal-630">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title text-center" id="myModalLabel">SEARCH MATCH</h4>
                    </div>
                    {Object.keys(multipleSearchData).length <= 0 ? <AxiosIndicatorRunTimeLoader /> :
                        <div className="modal-body">
                            <div className="bg-blue-light p-2 mb-3">
                                <span className='text-black font-14 font-arial'><strong> You searched for {currentBom && currentBom.partNumber}, there
                                    are {currentBom?.productMatchCount} possible matches:</strong></span>
                            </div>
                            <div className='search-match-item'>
                                <div className='bs5 row'>
                                    {loader ? <AxiosIndicatorRunTimeLoader /> :
                                        <>
                                            <div className='col-12'>
                                                {selectedValue.map((item) => (
                                                    <>
                                                        <div className='d-flex align-items-center justify-content-between font-16 mb-1'>
                                                            <div>
                                                                <a onClick={() => removeSelectedValue(item.erpPartNumber)}>
                                                                    <img src={remove} className="me-1" height={16} width={16} />
                                                                </a> <strong className='font-apecru font-16 me-1'>{item.partNumber}</strong> <i>{item.manufacturerName ? 'by ' + item.manufacturerName : ''}</i>
                                                            </div>
                                                            <div>
                                                                <strong>{System.getFormatNumber({ amount: get_pricing_by_id({ ItemNumber: item.itemNumber })[0]?.marketPrice, maximumFractionDigits: 5, isDisplaySymbol: false })}</strong>
                                                            </div>
                                                        </div>
                                                    </>
                                                ))}
                                            </div>
                                            <div className='col-12 text-end'>
                                                <button className="bs5 btn btn-primary w155"
                                                    onClick={() => onApplySelected()}
                                                    disabled={!selectedValue.length}>
                                                    Apply Selected
                                                </button>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="search-match-wrapper">
                                {multipleSearchData && Object.keys(multipleSearchData).length > 0 && multipleSearchData?.Products &&
                                    Object.entries(multipleSearchData?.Products).map((v) => (
                                        <div key={v} className="search-match-item">
                                            <div className="search-match-text mb-3">
                                                <b>{v[1].ERPMFRPartNumber}</b><span> {v[1].ManufacturerName ? 'by ' + v[1].ManufacturerName : ''}</span>
                                                <div>{v[1].ShortDescription}</div>
                                            </div>
                                            <div className="bs5 row">
                                                <div className="col-4">
                                                    <div className="price-table-list price-table-list-with-border">
                                                        <CustomerPartNumberOptions
                                                            single_product={v[1]}
                                                            from={Constants.systemModules.BOM}
                                                            defaultValue={v[1].customerPartNumber}
                                                            updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER) => {
                                                                let CPNValue = v[1].customerPartNumber
                                                                if (CPNValue !== SELECTED_CUSTOMER_PART_NUMBER) {
                                                                    let param = {
                                                                        bomDetailId: currentBom?.bomDetailId,
                                                                        customerPartNumber: SELECTED_CUSTOMER_PART_NUMBER
                                                                    }
                                                                    await update_customer_part_number_by_bom_detail_by_id(param)
                                                                }
                                                            }}
                                                        />

                                                        <div className="m-0 font_bold_currency border-0 mb-2">
                                                            <div className="d-flex justify-content-between font-24 font-arial">
                                                                {get_pricing_by_id({ ItemNumber: v[1].ItemNumber })?.length > 0 &&
                                                                    (
                                                                        <div className="price dense-hide mb-2">
                                                                            <div className="pull-right font-bold">
                                                                                {System.getFormatNumber({ amount: get_pricing_by_id({ ItemNumber: v[1].ItemNumber })[0]?.marketPrice, maximumFractionDigits: 5, isDisplaySymbol: false })}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        </div>


                                                        <PriceTable
                                                            single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                                            single_product={v[1].ItemNumber}
                                                            single_product_pricing_list={get_pricing_by_id({ ItemNumber: v[1].ItemNumber })}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4 pe-0">
                                                    <div>
                                                        <div className="text-darkgreen  d-flex align-items-center">
                                                            <i className="fa fa-check-circle me-1"></i>
                                                            <span className="d-flex text-darkgreen w-100">
                                                                <b>{v[1].Stock || 0}- In Stock</b>
                                                            </span>
                                                        </div>
                                                        <div id="availability_cont_3_lead_time" className="grey">
                                                            <div className="addtn-inventory leadTime">
                                                                <div className="clearfix">
                                                                    <FactoryLeadTimeDisplay
                                                                        single_product={v[1]}
                                                                        single_product_inventory={get_inventory_by_id(v[1].ItemNumber)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="prod-option-icon sect-2">
                                                            <div className="bs5 d-flex flex-wrap">
                                                                <ProductLegends
                                                                    single_product={v[1]}
                                                                    onlyIcon={true} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4 align-self-end">

                                                    <>
                                                        <DisplayQtyMinQtyMult
                                                            single_product={v[1]}
                                                        />
                                                        {
                                                            !selectedValue.find(item => item.erpPartNumber === v[1].ERPPartNumber) ? (
                                                                <button className="bs5 btn btn-primary w-100" onClick={() => onSwapHandler(v[1])}>
                                                                    Select
                                                                </button>
                                                            ) : (
                                                                <button className="bs5 btn btn-primary w-100">
                                                                    <i className="fa fa-check-circle me-1" aria-describedby="popup-32"></i>
                                                                </button>
                                                            )
                                                        }

                                                    </>

                                                </div>
                                            </div>
                                        </div>
                                    ))

                                }
                            </div>

                            {multipleSearchData && currentBom?.productMatchCount > 10 &&
                                <a className="see-all-results text-blue2"
                                    onClick={() => {
                                        window.location.href = BOM.getBomProductListingRouteURL(
                                            currentBom.bomId,
                                            {
                                                bomDetailId: currentBom.bomDetailId,
                                                search: multipleSearchData && multipleSearchData.PartailSearch,
                                                searchColumn: multipleSearchData && multipleSearchData.BomSearchColumns && btoa(JSON.stringify(multipleSearchData.BomSearchColumns)),
                                                addFrom:'BomSearchMatch',
                                                no_match: true
                                            });
                                    }}>See all {currentBom?.productMatchCount} results</a>
                            }
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default BomSearchMatchPopup;